import type { ComponentProps, FC } from 'react';
import type { AMOUNT_SUPERSCRIPT } from '@george-labs.com/design-system/types/components/Amount';

import { LocalizedAmount } from '@shared/core-ui-amount';
import type { Amount } from '@shared/core-types';

import { HighlightCard } from '../components/HighlightCard';

type HighlightCardProps = Omit<ComponentProps<typeof HighlightCard>, 'value'>;

type Props = HighlightCardProps &
    Omit<
        ComponentProps<typeof LocalizedAmount>,
        'superscript' | 'amount' | 'showCurrency' | 'className' | 'children'
    > & {
        amount: Amount;
        bigAmount?: true;
        superscript?: `${AMOUNT_SUPERSCRIPT}`;
    };

export const AmountHighlight: FC<Props> = ({
    icon,
    label,
    amount,
    'data-cy': dataCy,
    valuePostfix,
    bigAmount,
    coloured,
    showNegativeInRedColor,
    superscript = 'auto',
    children,
    illustration,
}) => (
    <HighlightCard
        data-cy={dataCy}
        icon={icon}
        illustration={illustration}
        label={label}
        valuePostfix={valuePostfix}
        value={
            <LocalizedAmount
                data-cy={`${dataCy}-highlight-amount`}
                amount={amount}
                showCurrency
                coloured={coloured}
                className={bigAmount && 'g-h2'}
                showNegativeInRedColor={showNegativeInRedColor}
                superscript={superscript as AMOUNT_SUPERSCRIPT}
            />
        }
    >
        {children}
    </HighlightCard>
);
